import "./Form.css";
import React, { useState, useEffect } from "react";
import Select, { StylesConfig, SingleValue, ActionMeta } from "react-select";
import { axiosCreateNewCandidate } from "../../Services/CandidateService";
import { axiosGetAllCities } from "../../Services/CitiesService";
import PhoneInput from "react-phone-input-2";
import { NewCandidate } from "../../Classes/NewCandidate";
import { City } from "../../Classes/CityItem";
import { CandidateCampaignResponse } from "../../Classes/CandidateCampaignResponse";

const Form = (campaignResponse?: CandidateCampaignResponse) => {
  const [fullName, setFullName] = useState<string>("");
  const [city, setCity] = useState<City>();
  const [phone, setPhone] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  let [cities, setCities] = useState<City[]>([]);

  const getAllCities = async () => {
    const result = await axiosGetAllCities();
    if (result) {
      const filteredCities = result
        .filter(
          (city) =>
            city.CityName !== 'רילוקשיין לחו"ל' && city.Code !== undefined
        )
        .map((city) => ({
          ...city,
          label: city.CityName,
          value: city.CityId,
        }));
      setCities(filteredCities);
    }
  };

  const candidateValidation = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      fullName != "" &&
      fullName.split(" ").length != 1 &&
      city?.CityName != null &&
      phone != "" &&
      phone != null
    ) {
      setMessage("");
      window.location.href =
        window.location.href.slice(0, window.location.href.indexOf("/", 10)) +
        "/thankyou";
      var newCandidate = new NewCandidate(
        fullName,
        city.CityId,
        phone,
        campaignResponse?.CampaignId,
        campaignResponse?.ReferrerId
        // campaignResponse?.ReferrerDetailId,
        // campaignResponse?.SubReferrerDetailId
      );
      await axiosCreateNewCandidate(newCandidate);
    } else if (
      fullName == null ||
      fullName == "" ||
      fullName.split(" ").length != 2
    ) {
      setMessage("הכנס שם מלא");
    } else if (city?.CityName == null) {
      setMessage("הכנס עיר מגורים");
    } else if (phone == "" || phone == null) {
      setMessage("הכנס מספר פלאפון");
    }
  };

  const customStyles: StylesConfig<City, false> = {
    control: (base) => ({
      ...base,
      height: 40,
      fontSize: 16,
      border: "3px solid #e74a54",
      color: "#0f40b4",
      borderRadius: "0",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 100,
    }),
  };

  const handleCityChange = (newValue: SingleValue<City>) => {
    setCity(newValue || undefined);
  };

  useEffect(() => {
    getAllCities();
  }, []);

  return (
    <div className="form-container">
      <form className="register-form" onSubmit={candidateValidation}>
        <div className="col">
          <input
            type="text"
            placeholder="שם מלא"
            className="full-name"
            onChange={(e) => setFullName(e.target.value)}
            value={fullName}
            name="fullName"
          />
        </div>
        <div className="col">
          <Select
            options={cities}
            defaultValue={city}
            onChange={handleCityChange}
            placeholder={
              <div className="cities-select-placeholder">עיר מגורים</div>
            }
            styles={customStyles}
            className="cities-select"
          />
        </div>
        <div className="col phone">
          <PhoneInput
            placeholder="טלפון נייד"
            disableDropdown={true}
            country="il"
            containerClass="phoneNumber"
            autoFormat={true}
            inputStyle={{
              border: "3px solid #e74a54",
              borderWidth: "3px",
              color: "#0f40b4",
              borderRadius: "0",
              textAlign: "right",
            }}
            disableCountryCode={true}
            value={phone}
            onChange={setPhone}
            inputClass="phone-input"
            specialLabel=""
          />
        </div>
        <div className="col">
          <button className="form-field-button" type="submit">
            שליחה<i className="form-arrow left"></i>
          </button>
        </div>
        <div className="col error-message">{message}</div>
      </form>
    </div>
  );
};

export default Form;
